import React, { useEffect } from 'react';
import useGetReadStatus from '@web-mail/components/ReadMail/hooks/useGetReadStatus';
import StatusModal from './popoverContent';
import { apiHolder } from 'api';
import { Spin } from 'antd';
const systemApi = apiHolder.api.getSystemApi();
const ReadStatus = props => {
    const { data } = props;
    const { openRecordData, setOpenRecordData, readStatus: dataList, setReadStatus, debounceGetStatusOrDetail, getStatusOrDetail, getMailReadDetail, } = useGetReadStatus(data);
    useEffect(() => {
        debounceGetStatusOrDetail(data);
    }, [data]);
    return (React.createElement("div", { style: { width: process.env.BUILD_ISEDM ? '570px' : '375px' } }, dataList ? (React.createElement(StatusModal, { readListData: dataList, tid: data.entry.tid, account: data._account })) : (React.createElement("div", { style: { height: 350, width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' } },
        React.createElement(Spin, { tip: "" })))));
};
export default ReadStatus;
